var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEligiblePatients(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 560.82 581.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ee7404;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M468.38,430.41v21.16l-58.71,54.48v-12.27c.87-26.51,.76-48.59-1.02-66.89-6.59-67.85-36.07-83.63-123.46-79.96h-101.88c-110.96-4.66-128.57,22.03-124.48,146.85v87.45H0v-150.82c0-81.1,54.29-135.5,135.27-135.5h197.85c62.46,0,109.02,32.28,127.05,84.17,5.39,15.48,8.24,32.7,8.21,51.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    className: "cls-1",
    d: "M235.06,267.92c-74.19-.04-134.29-60.22-134.25-134.4,.03-53.93,32.31-102.61,81.98-123.63,68.74-27.89,147.08,5.23,174.97,73.97,27.34,67.38-3.9,144.27-70.48,173.5-16.52,7-34.28,10.59-52.22,10.56Zm0-208.9c-41.2,0-74.61,33.4-74.61,74.61s33.4,74.61,74.61,74.61,74.61-33.4,74.61-74.61c-.04-41.19-33.42-74.56-74.61-74.61Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "560.82 365.78 468.38 451.57 409.67 506.05 371.6 541.38 328.56 581.33 288.42 538.47 204.27 448.62 247.13 408.48 331.46 498.52 408.65 426.89 460.17 379.08 520.88 322.74 560.82 365.78"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEligiblePatients);
export default __webpack_public_path__ + "static/media/eligiblePatients.31b23750848a4fc261f49d8ba87b530e.svg";
export { ForwardRef as ReactComponent };